import Page from '../page';
import ProjectManager, { PROJECT_MANAGER_EVENT } from "./modules/project-manager";
import DateFixedManager from "./modules/date-fixed-manager";
import BackgroundManager from "./modules/background-manager";
import DateLeftManager, { DATE_LEFT_MANAGER_EVENT } from "./modules/date-left-manager";
import ProjectHeaderManager from "./modules/project-header-manager";
import ScrollListener from '../../helpers/scroll-listener';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import ScrollMagic from 'scrollmagic';

export default class HistoryIndex extends Page {

    _classes = {
        intro: 'js-loader',
        projectContainer: 'js-date-project-container',
        projectItem: 'js-project-item',
        projectHeader : 'js-project-header',
        header: 'js-header',
        dateContainer: 'js-date-project-container',
        dateItem: 'js-date-project-item'
    };
    _posYProjectItem = [];
    _posYDateItem = [];
    _heightDateItem = [];
    _indexProject = {
        old: 0,
        current: 0,
        next: 0
    };
    _indexDate = {
        old: 0,
        current: 0,
        next: 0
    };
    _margeCursor = window.innerHeight / 2;
    _heightHeader = 0;
    _isAreaHeader = true;
    _dateClicked = false;
    _saveOlderDate = false;
    _firstProjectByDate = [];
    _firstProjectMarge = [];
    _saveOlderProject = false;

    constructor(...args) {
        super(...args);

        this._isDesktop = ( ENV.template == 'desktop' );

        this._initBackgroundManager();
        this._initDateFixedManager();
        this._initDateLeftManager();
        this._initProjectHeadertManager();

        this._retrieveDOM();

        if( this._isDesktop ) {
            this._initClass();
        }

        this._initTls();

        this._initProjectManager();
        // this._initScrollMagic();
    }

    _retrieveDOM() {

        this.dom.views = {};

        // Intro
        this.dom.views.intro = document.body.querySelector('.' + this._classes.intro );

        // Dates
        this.dom.views.date = {
            container : this.dom.page.querySelector( '.' + this._classes.dateContainer ),
            items : null
        };
        this.dom.views.date.items = [].slice.call( this.dom.views.date.container.querySelectorAll( '.' + this._classes.dateItem ) );

        // Projects
        this.dom.views.project = {
            container : this.dom.page.querySelector( '.' + this._classes.projectContainer ),
            items : null
        };
        this.dom.views.project.items = [].slice.call( this.dom.views.project.container.querySelectorAll( '.' + this._classes.projectItem ) );

        // Header => add header to project list
        this.dom.views.header = this.dom.page.querySelector( '.' + this._classes.header );
        this.dom.views.project.items.unshift( this.dom.views.header );

        this._initDataDOM();
    }

    _initDataDOM() {
        this._projectLength = this.dom.views.project.items.length;
        this._dateLength = this.dom.views.date.items.length;
    }

    _initClass() {

        this._getFirstProjectByDate();
        this._getFirstProjectMarge();

        this._getPositionProjectItem();
        this._initCurrentIndexProject();

        this._getPositionDateItem();
        this._initCurrentIndexDate();
        this._getHeightDateItem();

        this._getHeightHeader();

        this._BackgroundManager._initClass();
        this._ProjectHeaderManager._initClass();
        this._DateFixedManager._initClass();
        this._DateLeftManager._initClass();
    }

    _getFirstProjectByDate() {

        for( let i = 0, j = this._dateLength; i < j; i++ ) {
            let firstChild = this.dom.views.date.items[i].firstElementChild;
            this._firstProjectByDate.push( this.dom.views.project.items.indexOf( firstChild ) );
        }
    }

    _getFirstProjectMarge() {

        let projetStyles = window.getComputedStyle( this.dom.views.project.items[ 1 ] );
        let projectPaddingTop = parseInt( projetStyles.getPropertyValue('padding-top').split('px')[0] );
        let projectPaddingBottom = parseInt( projetStyles.getPropertyValue('padding-bottom').split('px')[0] );

        for( let i = 0, j = this._firstProjectByDate.length; i < j; i++ ) {
            let indexProjet = this._firstProjectByDate[i];
            let projectHeader = this.dom.views.project.items[ indexProjet ].querySelector( '.' + this._classes.projectHeader );

            let headerHeight = 0;
            if( projectHeader ) {
                headerHeight = projectHeader.getBoundingClientRect().height;
            }

            let heigthTotal = ( headerHeight + projectPaddingTop + projectPaddingBottom ) / 2;
            this._firstProjectMarge.push( heigthTotal );
        }
    }

    _getPositionProjectItem() {

        for( let i = 0, j = this._projectLength; i < j; i++ ) {
            this._posYProjectItem[ i ] = this._getScroll() + this.dom.views.project.items[ i ].getBoundingClientRect().top;
        }
    }


    _initCurrentIndexProject() {
        let cursor = this._getScroll() + this._margeCursor;
        let currentIndexProject = 0;

        for( let i = 0, j = this._posYProjectItem.length; i < j; i++ ) {
            if( cursor < this._posYProjectItem[ i ] ) {
                break;
            } else {
                currentIndexProject = i;
            }
        }

        this._indexProject.current = currentIndexProject;
        this._indexProject.next = Math.min( (this._indexProject.current + 1), (this._projectLength - 1) );

        this._synchronizeIndexProject();
    }

    // HERE
    // _test() {
    //     let tt = this._posYProjectItem[ this._indexProject.current ];
    //     let bb = this.dom.views.project.items[this._indexProject.current];
    //     let ba = bb.getBoundingClientRect().height / 2;
    //     let aa = tt - ba - this._margeCursor;
    //     console.log( tt, ba, aa )
    //     // window.scrollTo(0, 0);
    //     setTimeout(() => {
    //         console.log('ttretetertert')
    //     TweenMax.to( window, 0.3, { scrollTo: { y: aa, autoKill:false } } )
    //     }, 15000)
    //
    // }

    _synchronizeIndexProject() {
        this._BackgroundManager.setIndex( this._indexProject );
        this._ProjectHeaderManager.setIndex( this._indexProject );
    }

    _getPositionDateItem() {

        for( let i = 0, j = this._dateLength; i < j; i++ ) {
            this._posYDateItem[ i ] = this._getScroll() + this.dom.views.date.items[ i ].getBoundingClientRect().top;
        }
    }

    _initCurrentIndexDate() {
        let cursor = this._getScroll() + this._margeCursor;
        let currentIndexDate = 0;

        for( let i = 0, j = this._posYDateItem.length; i < j; i++ ) {
            if( cursor < this._posYDateItem[ i ] ) {
                break;
            } else {
                currentIndexDate = i;
            }
        }

        this._indexDate.current = currentIndexDate;
        this._indexDate.next = Math.min( (this._indexDate.current + 1), (this._dateLength - 1) );

        this._synchronizeIndexDate();
    }

    _synchronizeIndexDate() {
        this._DateFixedManager.setIndex( this._indexDate );
        this._DateLeftManager.setIndex( this._indexDate );
    }

    _getHeightDateItem() {

        for( let i = 0, j = this._dateLength; i < j; i++ ) {
            this._heightDateItem[ i ] = this.dom.views.date.items[ i ].getBoundingClientRect().height;
        }
    }

    _getHeightHeader() {
        this._heightHeader = this._posYProjectItem[ 1 ];
    }

    show() {
        super.show();

        if( this._isDesktop == false ) {

            this._initClass();

            // Hide Intro
            this._hideIntro();

            this._BackgroundManager.initLoad();
            this._DateLeftManager.initLoad();
            this._DateFixedManager.initLoad();
            this._ProjectHeaderManager.initLoad();
        }
    }

    bind() {

        super.bind();

        if( this._isDesktop ) {
            window.addEventListener("load", (event) => {

                this._initClass();

                // Hide Intro
                this._hideIntro();

                this._BackgroundManager.initLoad();
                this._DateLeftManager.initLoad();
                this._DateFixedManager.initLoad();
                this._ProjectHeaderManager.initLoad();
            });
        }

        this._ScrollListener = new ScrollListener( this._update );

        for( let i = 0, j = this._ProjectManager.length; i < j; i++ ) {
            this._ProjectManager[i].on( PROJECT_MANAGER_EVENT.SHOW_MORE_OPEN, this._projectOpen.bind(this) );
            this._ProjectManager[i].on( PROJECT_MANAGER_EVENT.SHOW_MORE_CLOSE, this._projectClose.bind(this) );
        }

        this._DateLeftManager.on( DATE_LEFT_MANAGER_EVENT.CLICK_DATE, this._clickDateLeft.bind(this) );
    }

    _initProjectManager() {
        this._ProjectManager = [];

        for( let i = 1, j = this.dom.views.project.items.length; i < j; i++ ) {
            this._ProjectManager.push( new ProjectManager({
                container : this.dom.views.project.items[i]
            }) );
        }
    }

    _initDateFixedManager() {
        this._DateFixedManager = new DateFixedManager();
    }

    _initBackgroundManager() {
        this._BackgroundManager = new BackgroundManager();
    }

    _initDateLeftManager() {

        this._DateLeftManager = new DateLeftManager();
    }

    _initProjectHeadertManager() {
        this._ProjectHeaderManager = new ProjectHeaderManager();
    }

    _projectOpen( e ) {
        this._getPositionProjectItem();
        this._getHeightHeader();

        this._getPositionDateItem();
        this._getHeightDateItem();
        this._getProgressHeightCurrentDate( this._getScroll() );
    }

    _projectClose( e ) {
        this._getPositionProjectItem();
        this._getHeightHeader();

        this._getPositionDateItem();
        this._getHeightDateItem();
        this._getProgressHeightCurrentDate( this._getScroll() );
    }

    _clickDateLeft( index ) {
        this._dateClicked = index;
        this._saveOlderDate = this._indexDate.current;
        this._saveOlderProject = this._indexProject.current;

        let indexProject = this._firstProjectByDate[ this._dateClicked ];
        let margeProject = this._firstProjectMarge[ this._dateClicked ];
        let posYProject = this._posYProjectItem[ indexProject ];
        let scrollValue = posYProject + margeProject - this._margeCursor;

        TweenMax.to( this.dom.views.project.container, 0.3, { autoAlpha: 0, onComplete: () => {
                TweenMax.to( window, 1, { scrollTo: { y: scrollValue, autoKill:false } } )
                TweenMax.to( this.dom.views.project.container, 0.3, { autoAlpha: 1, delay: 1 } )
            } } );

        // let tl = new TimelineMax();
        //
        // tl
        //     .to( this.dom.views.project.container, 0.1, { autoAlpha: 0 } )
        //     .to( window, 1, { scrollTo: { y: this._posYDateItem[ index ] + this._margeCursor } } )
        //     .to( this.dom.views.project.container, 0.1, { autoAlpha: 1 } )

        // TweenMax.to( window, 1, { scrollTo: { y: this._posYDateItem[ index ] - 50 } } )
    }

    resize(width, height) {

        this._margeCursor = window.innerHeight / 2;

        this._getFirstProjectMarge();

        this._getPositionProjectItem();
        this._getHeightHeader();

        this._getPositionDateItem();
        this._getHeightDateItem();

        for( let i = 0, j = this._ProjectManager.length; i < j; i++ ) {
            this._ProjectManager[i].resize();
        }

        this._DateLeftManager.resize();
    }

    _update(top) {

        this._getCurrentIndexDate( top );

        this._toggleHeaderArea( top );

        this._getCurrentIndexProject( top );

        this._getProgressHeightCurrentDate( top );

        if( this._dateClicked !== false && this._dateClicked == this._indexDate.current ) {
            this._dateClicked = false;
            this._DateLeftManager._endAnimDateClicked();
        }
    }

    _toggleHeaderArea( top ) {
        let cursor = top + this._margeCursor;

        if(
            ( cursor < this._heightHeader && this._isAreaHeader == true )
            || ( cursor > this._heightHeader && this._isAreaHeader == false )
        ) {
            return;
        }

        if( cursor < this._heightHeader && this._isAreaHeader == false ) {
            this._isAreaHeader = true;
            this._DateFixedManager.hide();
            this._DateLeftManager.hide();

        } else if ( cursor > this._heightHeader && this._isAreaHeader ){
            this._isAreaHeader = false;
            this._DateFixedManager.show();
            this._DateLeftManager.show();
        }
    }

    _getCurrentIndexProject( top ) {

        let cursor = top + this._margeCursor;

        if(
            ( cursor < this._posYProjectItem[ 0 ] )
            || ( cursor > this._posYProjectItem[ this._projectLength - 1 ] && this._indexProject.current == (this._projectLength - 1) )
            || ( cursor > this._posYProjectItem[ this._indexProject.current ] && cursor < this._posYProjectItem[ this._indexProject.next ] )
        ) {
            return;
        }

        this._indexProject.old = this._indexProject.current;
        let direction = '';

        if( cursor < this._posYProjectItem[ this._indexProject.current ] ) {
            this._indexProject.current = Math.max( ( this._indexProject.current - 1 ), 0 );
            direction = 'prev';

        } else if( cursor > this._posYProjectItem[ this._indexProject.current ] ) {
            this._indexProject.current = this._indexProject.next;
            direction = 'next';
        }

        this._indexProject.next = Math.min( (this._indexProject.current + 1), (this._projectLength - 1) );



        if( this._dateClicked === false || this._firstProjectByDate[ this._dateClicked ] == this._indexProject.current ) {

            if( this._dateClicked !== false && this._firstProjectByDate[ this._dateClicked ] == this._indexProject.current ) {
                this._indexProject.old = this._saveOlderProject ;
            }

            // this._synchronizeIndexProject();

            this._BackgroundManager.updateBackground( direction );
            this._ProjectHeaderManager.updateProjectHeader( direction );
        }
    }

    _getCurrentIndexDate( top ) {

        let cursor = top + this._margeCursor;

        if(
            ( cursor < this._posYDateItem[ 0 ] )
            || ( cursor > this._posYDateItem[ this._dateLength - 1 ] && this._indexDate.current == (this._dateLength - 1) )
            || ( cursor > this._posYDateItem[ this._indexDate.current ] && cursor < this._posYDateItem[ this._indexDate.next ] )
        ) {
            return;
        }

        this._indexDate.old = this._indexDate.current;
        let direction = '';

        if( cursor < this._posYDateItem[ this._indexDate.current ] ) {
            this._indexDate.current = Math.max( ( this._indexDate.current - 1 ), 0 );
            direction = 'prev';

        } else if( cursor > this._posYDateItem[ this._indexDate.current ] ) {
            this._indexDate.current = this._indexDate.next;
            direction = 'next';
        }

        this._indexDate.next = Math.min( (this._indexDate.current + 1), (this._dateLength - 1) );


        if( this._dateClicked === false || this._dateClicked == this._indexDate.current ) {

            if( this._dateClicked !== false && this._dateClicked == this._indexDate.current ) {
                this._indexDate.old = this._saveOlderDate;
            }

            // this._synchronizeIndexDate();

            this._DateFixedManager._updateDate( direction );
            this._DateLeftManager._updateDate( direction );
        }
    }

    _getProgressHeightCurrentDate( top ) {

        let cursor = top + this._margeCursor;

        if(
            ( cursor < this._posYDateItem[ 0 ] )
        ) {
            return;
        }

        let progressHeight = ( cursor - this._posYDateItem[ this._indexDate.current ] ) / this._heightDateItem[ this._indexDate.current ];

        progressHeight = Math.max(0, progressHeight );
        progressHeight = Math.min( progressHeight, 1 );

        this._DateLeftManager._updateCurrentProgressBar( progressHeight );
    }

    _getScroll() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    }

    // getTest() {
    //     return this.dom.views.project.items[0].offsetHeight;
    // }

    _initScrollMagic() {
        this._scrollMagicController = new ScrollMagic.Controller( {
            globalSceneOptions: {reverse: true}
        } );
        this._scrollMagicScenes = [];


        // Create Tweenmax Animation
        let tweenBackground = new TimelineMax();


        tweenBackground
            .fromTo( this.dom.views.datesFixed, 5, {scale: 1.5}, { scale: 1, ease: Power1.easeOut }, 'init')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic
            .Scene({
                triggerElement: this.dom.views.project.items[0],
                offset: (-window.innerHeight / 2),
                duration: this.getTest.bind(this)
            })
            .addIndicators();
        scene.setTween( tweenBackground );

        scene.addTo(this._scrollMagicController);
        this._scrollMagicScenes.push( scene );
    }

    _hideIntro(){
        setTimeout(()=>{
            this.dom.views.intro.classList.add('animateOut');
        }, 6000);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/history/history-index.js